import { useContext } from 'react'

import { BreadcrumbsContext } from 'context/breadcrumbs/breadcrumbsContext/BreadcrumbContext'

export const useBreadcrumbs = () => {
    const breadcrumbsContext = useContext(BreadcrumbsContext)

    return breadcrumbsContext
}
